import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import PageLoading from '../components/PageLoading';
import ChunkLoadErrorBoundary from '../components/ChunkLoadErrorBoundary';

const BlankLayout: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <ChunkLoadErrorBoundary>
        <Suspense fallback={<PageLoading fullPage />}>
          <Outlet />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </div>
  );
};

export default BlankLayout;
